<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :apiUrl="apiUrl"
      modalSize="lg"
      withoutDelete>

      <template #filter="scope">
        <div class="row">
          <div class="col">
            <v-select
              v-model="scopedFilterData.companyId"
              :options="listCompanies"
              :reduce="item => item.ID"
              placeholder="Instansi / OPD"
              label="Name"
              @input="onRefresh"/>
          </div>
        </div>
      </template>

      <template #additionalButton="scope">
        <button type="button" class="btn btn-sm btn-warning" @click="showDetail">Ubah Status</button>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :search="search"
      :filter="scopedFilterData"
      @onSelectItem="selectedItem = $event"
      @onDblClicked="item => showDetail(item)"/>

    <b-modal id="modalFaces" hide-footer no-close-on-backdrop size="xl" title="Daftar Wajah" header-class="bg-light text-primary py-1">

      <b-table-lite
        v-if="selectedItem"
        :items="selectedItem.Faces"
        :fields="faceTableFields"
        head-variant="light"
        small
        outlined>

        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.key === 'Action' && '40px' }">

        </template>

        <template #cell(Active)="data">
          <span v-html="data.value"></span>
        </template>

        <template #cell(Action)="data">
          <a href="#" class="text-danger" @click="toggleActive(data.item.ID, data.item.Active)">{{ data.item.Active ? 'Non-Aktifkan' : 'Aktifkan' }}</a>
        </template>
      </b-table-lite>

    </b-modal>

  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.loadOptionData()
    this.onRefresh()
  },
  data() {
    return {
      apiUrl: '/employee-face',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Nama Pegawai' },
        // { key: 'Faces', label: 'Wajah Terdaftar', formatter: value => value.length }
        { key: 'Faces', label: 'Wajah Terdaftar', formatter: value => {
          if (value.length > 0) {
            return '<span class="badge badge-success">' + value.length + '</span>'
          } else {
            return '<span class="badge badge-danger">' + value.length + '</span>'
          }
        }},
        { key: 'FacesActive', label: 'Wajah Aktif', formatter: (value, key, item) => {
          const countActive = item.Faces.filter(item => item.Active).length

          if (countActive > 0) {
            return '<span class="badge badge-success">' + countActive + '</span>'
          } else {
            return '<span class="badge badge-danger">' + countActive + '</span>'
          }
        }},
      ],
      selectedItem: null,
      search: '',
      listCompanies: [],
      scopedFilterData: {
        companyId: null
      },
      faceTableFields: [
        // { key: 'index', label: 'No.' },
        { key: 'ID', label: 'ID Wajah' },
        { key: 'CreatedAt', label: 'Tanggal terdaftar', formatter: value => this.$helper.formatDate(value) },
        { key: 'Active', label: 'Status?', formatter: value => {
          if (value) {
            return '<span class="badge badge-success">Aktif</span>'
          } else {
            return '<span class="badge badge-danger">Tidak Aktif</span>'
          }
        }},
        { key: 'Action', label: '' }
      ]
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      this.$axios.get('/company').then((res) => {
        this.listCompanies = res.data
      })
    },
    onChangeType () {
      this.onRefresh()
    },
    showDetail (item) {
      this.selectedItem = (item.constructor === Object) ? item : this.selectedItem

      this.$bvModal.show('modalFaces')
    },
    toggleActive (FaceId, active) {
      if (this.selectedItem) {
        // if (this.selectedItem.Face === '') {
        //   this.$bvToast.toast('Wajah Belum Terdaftar', {
        //     title: 'Gagal!!',
        //     variant: 'danger',
        //     solid: true
        //   })

        //   return
        // }

        const url = `/employee-face/${FaceId}`

        this.$axios.post(url, { Active: !active }).then(res => {
          this.$emit('refreshTable')

          this.$bvToast.toast('Berhasil disimpan', {
            title: 'Sukses!!',
            variant: 'success',
            solid: true
          })

          this.$bvModal.hide('modalFaces')
        })
      }
    }
  }
}
</script>
